import RoleRepository from "../domain/data/RoleRepository";
import Role from "../domain/entities/Role";
import User from "../domain/entities/User";
import { roles } from "./InitData";

export default class MockRoleRepository implements RoleRepository{

    async getRoles(user: User): Promise<Role[]> {
        return roles;
    }
    
}